

   import * as Sentry from '@sentry/browser';

  Sentry.init({
    dsn: 'https://ff578f51145c46029b2d34e8fed9ccd5@o568416.ingest.us.sentry.io/5713470',

    integrations: [Sentry.browserTracingIntegration()],
    environment: 'production',
    debug: false,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1
  });

  if (window.currentUserId) {
    Sentry.setUser({ id: window.currentUserId });
  }


